<label class="lineout pointer row-compact align-center">
	<input type="checkbox" data-ref="enabled" title="enabled">
	<div class="list wide">
		<div data-ref="name"></div>
		<div class="hint" data-ref="details"></div>
	</div>
	<button class="lineout" data-ref="remove" title="remove">✖</button>
</label>
